export const isStopTranscript = (transcript: string): boolean =>
  /^(?:please\s+)?stop(?:\s+(?:the\s+)?(?:microphone|mic|voice|charting|recording))?[.!?,\s]*$/i.test(
    transcript.trim(),
  )

/** ASR often emits "twenty-seven" as one token; parsers expect "twenty seven". */
export const splitHyphenatedTens = (text: string): string =>
  text.replace(/\b(twenty|thirty)[-–—]\s*/gi, '$1 ')
